import { render, staticRenderFns } from "./HomeFrame.vue?vue&type=template&id=2baace76&"
import script from "./HomeFrame.vue?vue&type=script&lang=js&"
export * from "./HomeFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports